import µUtils from '../libs/utils'
import http from '@/libs/http'

/*
	NOTICE:
	- every action starts with an underscore
*/

const actions: any = {
	//? HUBS
	//? GET ALL HUBS

	// async _listAllInventory({ state, dispatch }: any) {
	// 	try {
	// 		const config = await dispatch("_config")
	// 		const resp = await axios.get(env.apiUrl + `/api/v1/inventory/list`, config)
	// 		return resp.data
	// 	} catch (error: any) {
	// 		console.error(error)
	// 		const msg = error.response?.data?.msg || error.response?.data || error.message
	// 		return []
	// 	}
	// },

	async _inventoryDeleteItem({ state, dispatch }: any, _id) {
		try {
			// const config = await dispatch('_config')
			// const resp = await axios.delete(env.apiUrl + `/api/v1/inventory/delete/${_id}`, config)
			// // console.log(resp);
			// await dispatch('_listAllBatch', ['inventory'])
			// return true
			const resp = await http.deleteAuth<any>(`/api/v1/inventory/delete/${_id}`)
			await dispatch('_listAllBatch', ['inventory'])
			return true
		} catch (error: any) {
			console.error(error)
			const msg = error.response?.data?.msg || error.response?.data || error.message
			µUtils.µ_error(msg)
			return false
		}
	},
	async _inventoryUpdateItem({ state, dispatch }: any, data) {
		try {
			// const config = await dispatch('_config')
			// const resp = await axios.post(env.apiUrl + `/api/v1/inventory/update/${data._id}`, data, config)
			// console.log(resp)
			// await dispatch('_listAllBatch', ['inventory'])
			// return true
			const resp = await http.postAuth<any>(`/api/v1/inventory/update/${data._id}`, data)
			await dispatch('_listAllBatch', ['inventory'])
			return true
		} catch (error: any) {
			console.error(error)
			const msg = error.response?.data?.msg || error.response?.data || error.message
			µUtils.µ_error(msg)
			return false
		}
	},

	async _inventoryAddItem({ state, dispatch }: any, data) {
		try {
			// const config = await dispatch('_config')
			// const resp = await axios.post(env.apiUrl + `/api/v1/inventory/add`, data, config)
			// console.log(resp.data)
			// await dispatch('_listAllBatch', ['inventory'])
			// return resp.data?.data || ''
			const resp = await http.postAuth<any>(`/api/v1/inventory/add`, data)
			await dispatch('_listAllBatch', ['inventory'])
			return resp.data?.data || ''
		} catch (error: any) {
			console.error(error)
			const msg = error.response?.data?.msg || error.response?.data || error.message
			µUtils.µ_error(msg)
			return ''
		}
	},

	async _updateInventoryMeta({ state, dispatch }: any, data: any) {
		try {
			// const config = await dispatch('_config')
			// const resp = await axios.post(env.apiUrl + `/api/v1/inventorymeta/update`, data, config)
			// await dispatch('_listAllBatch', ['inventorymeta'])
			// console.log(resp.data)
			// return resp.data
			const resp = await http.postAuth<any>(`/api/v1/inventorymeta/update`, data)
			await dispatch('_listAllBatch', ['inventorymeta'])
			return resp.data
		} catch (error: any) {
			console.error(error)
			const msg = error.response?.data?.msg || error.response?.data || error.message
			µUtils.µ_error(msg)
			return []
		}
	},
}

export default actions
